var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1729_9776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8861 8.75L13.9625 3.67697C13.9859 3.56659 13.9519 3.45186 13.8721 3.37208L13.2965 2.79653C13.1943 2.69428 13.0378 2.66962 12.909 2.73546L10.4731 3.98139C10.332 4.0536 10.1595 4.01637 10.0607 3.89236L7.75634 1.0006C7.69309 0.921233 7.59713 0.875 7.49565 0.875H6.50435C6.40287 0.875 6.30691 0.921233 6.24366 1.0006L3.93934 3.89236C3.84053 4.01637 3.66803 4.0536 3.52686 3.98139L1.09097 2.73546C0.962229 2.66962 0.80572 2.69428 0.703472 2.79653L0.127919 3.37208C0.0481357 3.45186 0.0141286 3.56659 0.0375462 3.67697L1.11388 8.75H12.8861Z",
    fill: "#FFD811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43152 10.5L1.65041 11.7027C1.70809 12.0196 1.98416 12.25 2.3063 12.25H11.6937C12.0159 12.25 12.2919 12.0196 12.3496 11.7027L12.5685 10.5H1.43152Z",
    fill: "#FEDB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8861 8.75H1.11389L1.43152 10.5H12.5685L12.8861 8.75Z",
    fill: "#FFA62E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1729_9776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.eed0b5130255a09efea1767bd692dfc8.svg";
export { ForwardRef as ReactComponent };